import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { RootState } from '../../store/store';

type SidebarLinkProps = {
  title: string;
  link: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  activeIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  showCount?: boolean;
};

const SidebarLink: React.FC<SidebarLinkProps> = ({
  link,
  title,
  icon: Icon,
  activeIcon: ActiveIcon,
  showCount = false
}) => {
  const location = useLocation();
  const isActive =
    location.pathname === link || location.pathname.startsWith(`${link}/`);
  const { alertsCount } = useSelector((state: RootState) => state.alerts);
  const { unreadCount } = useSelector((state: RootState) => state.chat);
  
  let count = 0;
  if (link === '/alerts' && alertsCount) {
    count = alertsCount;
  } else if (link === '/chat' && unreadCount) {
    count = unreadCount;
  }
  
  return (
    <NavLink
      to={link}
      className={'sidebar-link ' + (isActive ? 'active-link' : 'hover-allowed')}
    >
      {isActive ? (
        <ActiveIcon className='sidebar-icon' />
      ) : (
        <Icon className='sidebar-icon' />
      )}
      <span>{title}</span>
      {showCount && count > 0 ? (
        <span className='alerts-count'>{count}</span>
      ) : null}
    </NavLink>
  );
};

export default SidebarLink;
